import DigitalizationProjectContentTypes from '@/components/DigitalizationProjectContentTypes/DigitalizationProjectContentTypes.vue';
import CheckBotConfigsManagement from '@/components/CheckBotConfigsManagement/CheckBotConfigsManagement.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DigitalizationProjectSettings',

  components: {
    CheckBotConfigsManagement,
    DigitalizationProjectContentTypes,
  },

  props: {
    digitalizationProjectId: {
      type: String,
      required: true,
    },
  },
});
